export enum BiSearchOrigin {
  EditorSearchBar = 'editor_search_bar',
  ResultPageSearchBar = 'result_page_search_bar',
  Sort = 'sort',
  PageChange = 'page_change',
  TabChange = 'tab_change',
  Facets = 'facets',
  ClearFacets = 'clear_facets',
  Other = 'other',
}
